import React from "react";
import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
  Paper,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { styled } from "@mui/material/styles";

const ScoreBox = styled(Paper)(({ theme }) => ({
  position: "relative",
  display: "inline-flex",
  padding: theme.spacing(3),
  borderRadius: "50%",
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: theme.shadows[6],
  },
}));

const ScoreContent = styled(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1,
  width:55,
  height:55,
});

const StyledCircularProgress = styled(CircularProgress)(({ theme, score }) => ({
  position: "absolute",
  left: "-19%",
  top: "-17.5%",
  transform: "translate(-50%, -50%)",
  color:
    score >= 60
      ? theme.palette.success.main
      : score >= 40
      ? theme.palette.warning.main
      : theme.palette.error.main,
  transition: "all 0.3s ease-in-out",
}));

const ScoreText = styled(Typography)(({ theme, score }) => ({
  fontWeight: 700,
  fontSize: "1.75rem",
  color:
    score >= 60
      ? theme.palette.success.main
      : score >= 40
      ? theme.palette.warning.main
      : theme.palette.error.main,
  transition: "color 0.3s ease-in-out",
}));

const ScoreMatching = ({ score }) => {
  const tooltipText =
    "AI-Generated Compatibility Score: This percentage represents how well the candidate's CV matches the job requirements.";

  const getScoreLabel = (score) => {
    if (score >= 60) return "Strong Match";
    if (score >= 40) return "Moderate";
    return "Low Match";
  };

  return (
    <Box sx={{ 
      position: "relative", display: "inline-flex" }}>
      <ScoreBox>
        <StyledCircularProgress
          size={140}
          thickness={4}
          variant="determinate"
          value={score}
          score={score}
        />
        <ScoreContent>
          <ScoreText score={score}>{score}%</ScoreText>
          <Typography
            variant="caption"
            sx={{
              opacity: 0.7,
              fontSize: "0.8rem",
            }}
          >
            {getScoreLabel(score)}
          </Typography>
        </ScoreContent>
      </ScoreBox>
      <Tooltip title={tooltipText} arrow placement="top">
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            right: -8,
            top: -8,
            bgcolor: "background.paper",
            boxShadow: 1,
          }}
        >
          <InfoIcon fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ScoreMatching;
